module.exports = __webpack_public_path__ + "img/checked.2d29dd19.gif";